module.exports = __webpack_public_path__ + "06bba3f20b23f2632b8f0a0f18def568.svg";